<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <div class="toolbar-filter-bar">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters" class="toolbar-filter-form">
                    <div class="toolbar-filter-fields">
                    <el-form-item>
                        <el-input v-model="filters.teacherName" placeholder="教师姓名" clearable class="toolbar-field-w-md"
                            @clear="onTeacherNameCleared"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-select v-model="filters.operationType" placeholder="统计类型" clearable
                            class="toolbar-field-w-type" @change="handleSearch">
                            <el-option label="全部类型" :value="0"></el-option>
                            <el-option label="代课" :value="1"></el-option>
                            <el-option label="被代课" :value="2"></el-option>
                            <el-option label="调课" :value="3"></el-option>
                            <el-option label="教务安排(待指派)" :value="4"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-select v-model="filters.reasonType" placeholder="申请原因" clearable
                            class="toolbar-field-w-md" @change="handleSearch">
                            <el-option v-for="item in reasonTypeOptions" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-select v-model="selectedSemesterId" placeholder="学期" @change="handleSemesterChange"
                            class="toolbar-field-w-md">
                            <el-option v-for="sem in semesterList" :key="sem.Id" :label="sem.SemesterName"
                                :value="sem.Id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item style="margin-left: 20px;">
                        <el-link :type="timeRange === 'today' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('today')" style="margin-right: 15px;"
                            :underline="false">今日</el-link>
                        <el-link :type="timeRange === 'week' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('week')" style="margin-right: 15px;"
                            :underline="false">本周</el-link>
                        <el-link :type="timeRange === 'month' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('month')" style="margin-right: 15px;"
                            :underline="false">本月</el-link>
                        <el-link :type="timeRange === 'semester' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('semester')" style="margin-right: 15px;"
                            :underline="false">全学期</el-link>

                        <el-dropdown trigger="click" @command="handleCustomTimeCommand" style="margin-right: 20px;"
                            placement="bottom">
                            <span class="el-dropdown-link"
                                :style="{ color: timeRange === 'custom' ? 'var(--btn-primary, #2563eb)' : '#606266', cursor: 'pointer', fontSize: '14px' }">
                                自定义时间<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" style="padding: 10px;">
                                <div @click.stop>
                                    <el-date-picker v-model="filters.dateRange" type="daterange" format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
                                        :clearable="false" size="small" @change="onCustomDateChange"
                                        class="toolbar-field-w-daterange">
                                    </el-date-picker>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" v-on:click="handleSearch">查询</el-button>
                    </el-form-item>
                    </div>
                    <div class="toolbar-filter-actions">
                        <el-button size="small" type="warning" icon="el-icon-download" @click="exportExcel"
                            :title="activeTab === 'applications' ? '导出当前筛选下的申请记录' : '导出统计与调课明细'">
                            {{ activeTab === 'applications' ? '导出申请记录' : '导 出' }}
                        </el-button>
                    </div>
                </el-form>
            </el-col>
            </div>

            <el-tabs v-model="activeTab" class="cas-tabs" @tab-click="onTabClick">
                <el-tab-pane label="统计" name="stats">
                    <div class="stat-summary" v-loading="listLoading">
                        <div class="stat-summary-item is-clickable" @click="showSummaryDetail(1)">
                            <span class="stat-summary-label">代课</span>
                            <span class="stat-summary-value">{{ summary.TotalSubstituteCount || 0 }}</span>
                        </div>
                        <div class="stat-summary-item is-clickable" @click="showSummaryDetail(2)">
                            <span class="stat-summary-label">被代课</span>
                            <span class="stat-summary-value">{{ summary.TotalBeSubstitutedCount || 0 }}</span>
                        </div>
                        <div class="stat-summary-item is-clickable" @click="showSummaryDetail(3)">
                            <span class="stat-summary-label">调课</span>
                            <span class="stat-summary-value">{{ summary.TotalSwapCount || 0 }}</span>
                        </div>
                        <div class="stat-summary-item is-pending is-clickable" @click="showSummaryDetail(4)">
                            <span class="stat-summary-label">教务安排(待指派)</span>
                            <span class="stat-summary-value">{{ summary.TotalAdminArrangePendingCount || 0 }}</span>
                        </div>
                    </div>

                    <div class="tbl-scroll-host">
                    <el-table :data="statistics" highlight-current-row v-loading="listLoading" height="100%" style="width: 100%;" border>
                        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
                        <el-table-column prop="TeacherName" label="教师" min-width="100" align="center"></el-table-column>
                        <el-table-column label="代课" min-width="80" align="center">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" @click="showDetail(scope.row, 1)">{{
                                    scope.row.SubstituteCount }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="被代课" min-width="80" align="center">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" @click="showDetail(scope.row, 2)">{{
                                    scope.row.BeSubstitutedCount || ((scope.row.BeSubstitutedPublicCount || 0) + (scope.row.BeSubstitutedPrivateCount || 0)) }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="调课" min-width="80" align="center">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" @click="showDetail(scope.row, 3)">{{
                                    scope.row.SwapCount }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="教务安排(待指派)" min-width="130" align="center">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" @click="showDetail(scope.row, 4)">{{
                                    scope.row.AdminArrangePendingCount || 0 }}</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>

                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange"
                            @size-change="handleSizeChange" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total"
                            style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>

                <el-tab-pane label="明细" name="detail">
                    <div class="app-scope-tip">
                        <i class="el-icon-info"></i>
                        <span>明细只含<strong>已通过</strong>课节。类型/原因用顶部筛选；本栏可搜老师、班级、课节、原因。</span>
                    </div>
                    <div class="detail-filter-bar">
                        <el-input
                            v-model="flatFilters.keyword"
                            placeholder="搜老师/班级/课节/原因"
                            clearable
                            size="small"
                            prefix-icon="el-icon-search"
                            class="detail-keyword-input"
                            @keyup.enter.native="getFlatDetails(1)"
                            @clear="getFlatDetails(1)">
                        </el-input>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="getFlatDetails(1)">查询</el-button>
                        <el-tag
                            v-if="flatFilters.teacherMasterId"
                            type="warning"
                            size="small"
                            closable
                            class="flat-focus-tag"
                            @close="clearFlatTeacherFocus">
                            下钻：{{ flatFilters.focusTeacherName || '指定教师' }}
                        </el-tag>
                    </div>

                    <div class="tbl-scroll-host">
                    <el-table :data="flatDetailList" border v-loading="flatDetailLoading" size="small" height="100%"
                        class="adjust-detail-table" :header-cell-style="{ whiteSpace: 'nowrap' }" style="width: 100%;">
                        <el-table-column property="Submitter" label="提交人" width="80" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column property="HandleTypeText" label="类型" width="110" align="center">
                            <template slot-scope="scope">
                                <el-tag
                                    :type="scope.row.HandleTypeText === '调课' ? 'warning' : (String(scope.row.HandleTypeText || '').indexOf('被代') === 0 ? 'info' : 'success')"
                                    size="mini"
                                    class="handle-type-tag">
                                    {{ scope.row.HandleTypeText }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="申请老师/班级" min-width="120" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <span class="detail-cell-main">{{ scope.row.OriginalTeacherName || '-' }}</span>
                                    <span class="detail-cell-sub">{{ scope.row.ClassName || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="课节安排" min-width="200" align="left">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack is-left" :title="(scope.row.LessonInfo || '') + '\n' + (scope.row.CourseName || '')">
                                    <span class="detail-cell-main">{{ scope.row.LessonInfo || '-' }}</span>
                                    <span class="detail-cell-sub">{{ scope.row.CourseName || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column property="NewTeacherName" label="被申请老师" width="96" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="原因" min-width="120" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <el-tag type="info" size="mini">{{ scope.row.ReasonTypeName || scope.row.Type || '-' }}</el-tag>
                                    <span class="detail-cell-sub" :title="scope.row.Reason">{{ scope.row.Reason || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态/时间" width="120" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <span class="detail-cell-main">{{ scope.row.Status || '-' }}</span>
                                    <span class="detail-cell-sub">{{ scope.row.ApplyTime || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="附件" width="100" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.AttachmentImageList && scope.row.AttachmentImageList.length" class="attach-thumbs">
                                    <oss-el-image
                                        v-for="(url, idx) in scope.row.AttachmentImageList"
                                        :key="idx"
                                        :src="url"
                                        :preview-src-list="scope.row.AttachmentImageList"
                                        :school-id="departmentId"
                                        fit="cover"
                                        class="attach-thumb"
                                    />
                                </div>
                                <span v-else class="attach-empty">-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>

                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="total, sizes, prev, pager, next, jumper"
                            @current-change="handleFlatDetailPageChange"
                            @size-change="handleFlatDetailSizeChange"
                            :current-page="flatDetailPage"
                            :page-size="flatDetailPageSize"
                            :page-sizes="[10, 20, 50, 100]"
                            :total="flatDetailTotal"
                            style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>

                <el-tab-pane label="申请记录" name="applications">
                    <div class="app-scope-tip">
                        <i class="el-icon-info"></i>
                        <span>左侧选<strong>学校</strong>看全部、选<strong>校区</strong>看该校区。顶部「类型/原因」与导出跟当前筛选一致。</span>
                    </div>
                    <div class="detail-filter-bar">
                        <el-select v-model="appFilters.status" placeholder="申请状态" clearable size="small"
                            class="detail-type-select" @change="getApplicationRecords(1)">
                            <el-option label="全部状态" :value="null"></el-option>
                            <el-option label="待审批" :value="0"></el-option>
                            <el-option label="已通过" :value="1"></el-option>
                            <el-option label="已驳回" :value="2"></el-option>
                            <el-option label="已撤销" :value="3"></el-option>
                        </el-select>
                        <el-input
                            v-model="appFilters.keyword"
                            placeholder="搜申请人/校区/课节/原因"
                            clearable
                            size="small"
                            prefix-icon="el-icon-search"
                            class="detail-keyword-input"
                            @keyup.enter.native="getApplicationRecords(1)"
                            @clear="getApplicationRecords(1)">
                        </el-input>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="getApplicationRecords(1)">查询</el-button>
                    </div>

                    <div class="tbl-scroll-host">
                    <el-table :data="appRecordList" border v-loading="appRecordLoading" size="small" height="100%"
                        class="adjust-detail-table" :header-cell-style="{ whiteSpace: 'nowrap' }" style="width: 100%;">
                        <el-table-column property="ApplicantTeacherName" label="申请人" width="88" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column property="CampusName" label="校区" min-width="120" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="申请时段" min-width="150" align="center">
                            <template slot-scope="scope">
                                <span class="app-cell-text" :title="formatAppDateRange(scope.row)">{{ formatAppDateRange(scope.row) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="HandleTypeSummary" label="类型" width="88" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="课节摘要" min-width="150" align="left">
                            <template slot-scope="scope">
                                <div class="app-lesson-cell" @click="openApplicationDetail(scope.row)">
                                    <span class="app-lesson-count">{{ getLessonCount(scope.row) }}节</span>
                                    <span class="app-lesson-preview">{{ getLessonPreview(scope.row) }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column property="AssignedTeacherNames" label="代课/对端教师" min-width="110" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="原因" min-width="120" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack">
                                    <el-tag type="info" size="mini" effect="plain">{{ scope.row.ReasonTypeName || '-' }}</el-tag>
                                    <span class="detail-cell-sub" :title="scope.row.ReasonDetail">{{ scope.row.ReasonDetail || '-' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态/审批人" width="128" align="center">
                            <template slot-scope="scope">
                                <div class="detail-cell-stack app-status-cell" @click="openApplicationDetail(scope.row)">
                                    <el-tag :type="appStatusTagType(scope.row.Status)" size="mini" effect="plain">
                                        {{ scope.row.StatusName || '-' }}
                                    </el-tag>
                                    <span class="detail-cell-sub" :title="scope.row.CurrentApproverNames">
                                        {{ scope.row.Status === 0 ? (scope.row.CurrentApproverNames || '待审批') : (scope.row.CreateTime || '-').toString().substring(0, 16).replace('T', ' ') }}
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="附件" width="100" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.AttachmentImageList && scope.row.AttachmentImageList.length" class="attach-thumbs">
                                    <oss-el-image
                                        v-for="(url, idx) in scope.row.AttachmentImageList"
                                        :key="idx"
                                        :src="url"
                                        :preview-src-list="scope.row.AttachmentImageList"
                                        :school-id="departmentId"
                                        fit="cover"
                                        class="attach-thumb"
                                    />
                                </div>
                                <span v-else class="attach-empty">-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>

                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="total, sizes, prev, pager, next, jumper"
                            @current-change="handleAppRecordPageChange"
                            @size-change="handleAppRecordSizeChange"
                            :current-page="appRecordPage"
                            :page-size="appRecordPageSize"
                            :page-sizes="[10, 20, 50, 100]"
                            :total="appRecordTotal"
                            style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>
            </el-tabs>

            <el-dialog
                title="申请记录详情"
                :visible.sync="applicationDialog.visible"
                width="960px"
                :close-on-click-modal="false"
                append-to-body
                custom-class="cas-application-dialog">
                <div v-if="applicationDialog.row" class="application-detail-dialog">
                    <div class="app-meta-bar">
                        <div class="app-meta-identity">
                            <span class="app-meta-name">{{ applicationDialog.row.ApplicantTeacherName || '-' }}</span>
                            <el-tag :type="appStatusTagType(applicationDialog.row.Status)" size="mini" effect="plain">
                                {{ applicationDialog.row.StatusName || '-' }}
                            </el-tag>
                        </div>
                        <div class="app-meta-fields">
                            <span class="app-meta-field"><em>校区</em>{{ applicationDialog.row.CampusName || '-' }}</span>
                            <span class="app-meta-field"><em>原因</em>{{ applicationDialog.row.ReasonTypeName || '-' }}</span>
                            <span class="app-meta-field"><em>时段</em>{{ formatAppDateRange(applicationDialog.row) }}</span>
                            <span class="app-meta-field app-meta-field--grow" :title="applicationDialog.row.ReasonDetail">
                                <em>说明</em>{{ applicationDialog.row.ReasonDetail || '-' }}
                            </span>
                        </div>
                    </div>

                    <div class="flow-panel">
                        <div class="flow-panel-head">
                            <div class="flow-panel-title">
                                <i class="el-icon-date"></i>
                                <span>课节明细</span>
                                <span class="flow-count">{{ getLessonCount(applicationDialog.row) }} 节</span>
                            </div>
                        </div>
                        <el-table
                            v-if="applicationDialog.lessonList.length"
                            :data="applicationDialog.lessonList"
                            size="mini"
                            border
                            max-height="240"
                            class="app-lesson-table">
                            <el-table-column type="index" label="#" width="40" align="center"></el-table-column>
                            <el-table-column label="课节" min-width="180" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ formatLessonPeriod(scope.row) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="ClassName" label="班级" width="90" align="center"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="CourseName" label="课程" width="120" align="center"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column label="类型" width="90" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="mini" effect="plain" :type="lessonHandleTagType(scope.row.HandleType)">
                                        {{ scope.row.HandleTypeName || '-' }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="代课/对端" min-width="88" align="center" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.NewTeacherName || (scope.row.HandleType === 3 ? '待指派' : '-') }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div v-else class="app-empty-tip">暂无课节明细</div>
                    </div>

                    <div class="flow-panel">
                        <div class="flow-panel-head">
                            <div class="flow-panel-title">
                                <i class="el-icon-s-check"></i>
                                <span>审批进度</span>
                                <span v-if="applicationDialog.row.CreateTime" class="flow-create-time">
                                    {{ formatDateTime(applicationDialog.row.CreateTime) }}
                                </span>
                                <span v-if="applicationDialog.row.ApprovalSteps && applicationDialog.row.ApprovalSteps.length"
                                    class="flow-count">
                                    {{ applicationDialog.row.ApprovalSteps.length }} 人
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="applicationDialog.row.ApprovalSteps && applicationDialog.row.ApprovalSteps.length"
                            class="approval-steps-grid">
                            <div
                                v-for="(step, index) in applicationDialog.row.ApprovalSteps"
                                :key="`${step.StepNumber}-${index}`"
                                class="approval-step-card"
                                :class="['step-tone-' + (((step.StepNumber || 1) - 1) % 4), 'is-' + (step.Status || 'Pending')]">
                                <div class="step-card-head">
                                    <div class="step-card-main">
                                        <span class="step-badge">{{ step.StepNumber }}</span>
                                        <span class="step-name">{{ step.ApproverName || '-' }}</span>
                                    </div>
                                    <el-tag size="mini" :type="approvalStepTagType(step.Status)" effect="plain">
                                        {{ approvalStepStatusText(step.Status) }}
                                    </el-tag>
                                </div>
                                <div class="step-card-time">
                                    {{ step.ApprovedAt ? formatDateTime(step.ApprovedAt) : '待处理' }}
                                </div>
                                <div v-if="step.Comments" class="step-card-comment">{{ step.Comments }}</div>
                            </div>
                        </div>
                        <div v-else class="app-empty-tip">暂无审批流程记录</div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="applicationDialog.visible = false">关闭</el-button>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import dateUtil from '../../../util/date';
import {
    getSpecialAdjustStatisticsList,
    exportSpecialAdjustStatistics,
    getSpecialAdjustStatisticsDetailList,
    getSpecialAdjustApplicationRecords,
    exportSpecialAdjustApplicationRecords,
    getSpecialCourseConfig
} from '../../api/modules/schedule-course';
import { getSemesterList } from '../../api/modules/misc';
import DepartmentPane from '@/components/DepartmentPane';

export default {
    components: { DepartmentPane },
    data() {
        return {
            departmentId: null,
            semesterList: [],
            selectedSemesterId: null,
            currentSemesterObj: null,
            filters: {
                teacherName: '',
                operationType: 0,
                reasonType: null,
                dateRange: []
            },
            timeRange: 'month',
            activeTab: 'stats',

            statistics: [],
            summary: {
                TotalSubstituteCount: 0,
                TotalBeSubstitutedCount: 0,
                TotalSwapCount: 0,
                TotalAdminArrangePendingCount: 0
            },

            total: 0,
            page: 1,
            pageSize: 10,
            listLoading: false,

            flatFilters: {
                keyword: '',
                teacherMasterId: 0,
                focusTeacherName: ''
            },
            reasonTypeOptions: [
                { value: 1, label: '因公' },
                { value: 2, label: '因私' },
                { value: 3, label: '病假' },
                { value: 4, label: '其他' }
            ],
            flatDetailList: [],
            flatDetailTotal: 0,
            flatDetailPage: 1,
            flatDetailPageSize: 10,
            flatDetailLoading: false,

            appFilters: {
                status: null,
                keyword: ''
            },
            appRecordList: [],
            appRecordTotal: 0,
            appRecordPage: 1,
            appRecordPageSize: 10,
            appRecordLoading: false,
            applicationDialog: {
                visible: false,
                row: null,
                lessonList: []
            }
        };
    },
    methods: {
        treeNodeClick(node) {
            let deptId = null;
            if (!node) deptId = null;
            else if (node.value !== undefined) deptId = node.value;
            else if (node.Id !== undefined) deptId = node.Id;
            else if (node.id !== undefined) deptId = node.id;

            this.departmentId = deptId;
            if (this.departmentId == 0) {
                this.$message({
                    message: '抱歉，暂不支持总平台级别的数据统计，请选择具体的学校。',
                    type: 'error'
                });
                this.statistics = [];
                this.summary = {
                    TotalSubstituteCount: 0,
                    TotalBeSubstitutedCount: 0,
                    TotalSwapCount: 0,
                    TotalAdminArrangePendingCount: 0
                };
                this.total = 0;
                this.flatDetailList = [];
                this.flatDetailTotal = 0;
                this.appRecordList = [];
                this.appRecordTotal = 0;
                return;
            }
            this.loadSemesters();
        },
        loadSemesters() {
            if (!this.departmentId) return;
            // 申请原因名称读「特殊课程配置」专用键。最后更新：2026-10-22
            getSpecialCourseConfig({ DepartmentId: this.departmentId }).then(res => {
                const data = (res && res.data && res.data.response) || (res && res.response) || null;
                if (data && Array.isArray(data.CourseAdjustmentReasonTypes) && data.CourseAdjustmentReasonTypes.length) {
                    this.reasonTypeOptions = data.CourseAdjustmentReasonTypes.map(x => ({
                        value: Number(x.Value),
                        label: x.Name || x.Label || ('原因' + x.Value)
                    }));
                }
            }).catch(() => {});
            getSemesterList({ departmentId: this.departmentId }).then(res => {
                if (res.success && res.response && res.response.length > 0) {
                    this.semesterList = res.response;
                    const current = res.response.find(s => s.IsCurrent === 1) || res.response[0];
                    this.selectedSemesterId = current.Id;
                    this.currentSemesterObj = current;
                    this.handleTimeRangeChange('semester');
                } else {
                    this.semesterList = [];
                    this.selectedSemesterId = null;
                    this.currentSemesterObj = null;
                    this.handleTimeRangeChange('month');
                }
            });
        },
        handleSemesterChange(val) {
            const s = this.semesterList.find(x => x.Id === val);
            if (s) {
                this.currentSemesterObj = s;
                if (this.timeRange === 'semester') {
                    this.handleTimeRangeChange('semester');
                } else {
                    this.handleSearch();
                }
            }
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getRecords();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getRecords(1);
        },
        handleCustomTimeCommand() {
            this.timeRange = 'custom';
        },
        /** 仅全学期模式传 SemesterId；其它时间模式只按调课日期。最后更新：2026-10-22 */
        resolveQuerySemesterId() {
            if (this.timeRange !== 'semester') return 0;
            return this.selectedSemesterId || 0;
        },
        onCustomDateChange(val) {
            if (val && val.length === 2) {
                this.timeRange = 'custom';
                this.handleSearch();
            }
        },
        handleTimeRangeChange(val) {
            this.timeRange = val;
            const todayDate = new Date();
            const todayStr = dateUtil.formatDate.format(todayDate, 'yyyy-MM-dd');
            let start = '';
            let end = '';

            if (val === 'today') {
                start = todayStr;
                end = todayStr;
            } else if (val === 'week') {
                start = dateUtil.formatDate.format(dateUtil.getStartOfWeek(todayDate), 'yyyy-MM-dd');
                end = dateUtil.formatDate.format(dateUtil.getEndOfWeek(todayDate), 'yyyy-MM-dd');
            } else if (val === 'month') {
                start = dateUtil.formatDate.format(dateUtil.getStartOfMonth(todayDate), 'yyyy-MM-dd');
                end = dateUtil.formatDate.format(dateUtil.getEndOfMonth(todayDate), 'yyyy-MM-dd');
            } else if (val === 'semester') {
                if (this.currentSemesterObj && this.currentSemesterObj.StartDate && this.currentSemesterObj.EndDate) {
                    start = this.currentSemesterObj.StartDate.substring(0, 10);
                    end = this.currentSemesterObj.EndDate.substring(0, 10);
                } else {
                    start = dateUtil.formatDate.format(dateUtil.addMonths(todayDate, -6), 'yyyy-MM-dd');
                    end = todayStr;
                }
            } else {
                return;
            }

            this.filters.dateRange = [start, end];
            this.handleSearch();
        },
        handleSearch() {
            if (!(this.filters.teacherName || '').trim()) {
                this.flatFilters.teacherMasterId = 0;
                this.flatFilters.focusTeacherName = '';
            }
            if (this.activeTab === 'detail') {
                this.getFlatDetails(1);
            } else if (this.activeTab === 'applications') {
                this.getApplicationRecords(1);
            } else {
                this.getRecords(1);
            }
        },
        onTeacherNameCleared() {
            this.flatFilters.teacherMasterId = 0;
            this.flatFilters.focusTeacherName = '';
            if (this.activeTab === 'detail') {
                this.getFlatDetails(1);
            } else if (this.activeTab === 'applications') {
                this.getApplicationRecords(1);
            }
        },
        onTabClick() {
            if (this.activeTab === 'detail') {
                this.getFlatDetails();
            } else if (this.activeTab === 'applications') {
                this.getApplicationRecords();
            } else {
                this.getRecords();
            }
        },
        buildSharedQueryParams(page, pageSize) {
            let startDate = '';
            let endDate = '';
            if (this.filters.dateRange && this.filters.dateRange.length === 2) {
                startDate = this.filters.dateRange[0];
                endDate = this.filters.dateRange[1];
            }
            const para = {
                Page: page,
                PageSize: pageSize,
                TeacherName: this.filters.teacherName,
                StartDate: startDate,
                EndDate: endDate,
                DepartmentId: this.departmentId,
                SemesterId: this.resolveQuerySemesterId()
            };
            if (this.filters.operationType > 0) {
                para.OperationType = this.filters.operationType;
            }
            if (this.filters.reasonType) {
                para.ReasonType = this.filters.reasonType;
            }
            return para;
        },
        getRecords(resetPage) {
            if (resetPage) this.page = resetPage;
            if (!this.departmentId) return;

            const para = this.buildSharedQueryParams(this.page, this.pageSize);
            this.listLoading = true;
            getSpecialAdjustStatisticsList(para).then(res => {
                if (res.success) {
                    this.total = res.response.PageData.dataCount;
                    this.statistics = res.response.PageData.data;
                    this.summary = res.response.Summary || {};
                } else {
                    this.$message.error(res.msg || '获取统计失败');
                }
                this.listLoading = false;
            }).catch(() => {
                this.listLoading = false;
                this.$message.error('网络请求异常');
            });
        },
        exportExcel() {
            if (this.activeTab === 'applications') {
                return this.exportApplicationRecords();
            }
            const para = this.buildSharedQueryParams(1, 999999);
            return exportSpecialAdjustStatistics(para).then(res => {
                this.downloadBlob(res.data, `特殊课程代调课统计报表_${dateUtil.formatDate.format(new Date(), 'yyyyMMddhhmmss')}.xlsx`);
            }).catch(() => {
                this.$message.error('导出失败');
            });
        },
        exportApplicationRecords() {
            if (!this.departmentId) {
                this.$message.warning('请先选择学校或部门');
                return;
            }
            const para = Object.assign(this.buildSharedQueryParams(1, 999999), {
                Keyword: this.appFilters.keyword || ''
            });
            if (this.appFilters.status === 0 || this.appFilters.status > 0) {
                para.Status = this.appFilters.status;
            }
            return exportSpecialAdjustApplicationRecords(para).then(res => {
                this.downloadBlob(res.data, `特殊课程代调课申请记录_${dateUtil.formatDate.format(new Date(), 'yyyyMMddhhmmss')}.xlsx`);
            }).catch(() => {
                this.$message.error('导出申请记录失败');
            });
        },
        downloadBlob(blob, fileName) {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
        /**
         * 顶部汇总进明细。OperationType：1代课 2被代课 3调课 4教务安排待指派。最后更新：2026-10-22
         */
        showSummaryDetail(type) {
            if (type === 1 && !(this.summary.TotalSubstituteCount > 0)) return;
            if (type === 2 && !(this.summary.TotalBeSubstitutedCount > 0)) return;
            if (type === 3 && !(this.summary.TotalSwapCount > 0)) return;
            if (type === 4 && !(this.summary.TotalAdminArrangePendingCount > 0)) return;

            this.filters.operationType = type;
            this.flatFilters.teacherMasterId = 0;
            this.flatFilters.focusTeacherName = '';
            this.flatFilters.keyword = '';
            this.activeTab = 'detail';
            this.getFlatDetails(1);
        },
        /**
         * 表格数字下钻明细。最后更新：2026-10-22
         */
        showDetail(row, type) {
            if (!row) return;
            const beSub = row.BeSubstitutedCount || ((row.BeSubstitutedPublicCount || 0) + (row.BeSubstitutedPrivateCount || 0));
            if (type === 1 && !(row.SubstituteCount > 0)) return;
            if (type === 2 && !(beSub > 0)) return;
            if (type === 3 && !(row.SwapCount > 0)) return;
            if (type === 4 && !(row.AdminArrangePendingCount > 0)) return;

            this.filters.operationType = type;
            this.flatFilters.teacherMasterId = row.TeacherMasterId || 0;
            this.flatFilters.focusTeacherName = row.TeacherName || '';
            this.flatFilters.keyword = '';
            this.filters.teacherName = row.TeacherName || '';
            this.activeTab = 'detail';
            this.getFlatDetails(1);
        },
        clearFlatTeacherFocus() {
            this.flatFilters.teacherMasterId = 0;
            this.flatFilters.focusTeacherName = '';
            this.filters.teacherName = '';
            this.getFlatDetails(1);
        },
        handleFlatDetailPageChange(val) {
            this.flatDetailPage = val;
            this.getFlatDetails();
        },
        handleFlatDetailSizeChange(val) {
            this.flatDetailPageSize = val;
            this.getFlatDetails(1);
        },
        getFlatDetails(resetPage) {
            if (resetPage) this.flatDetailPage = resetPage;
            if (!this.departmentId) return;

            const para = Object.assign(this.buildSharedQueryParams(this.flatDetailPage, this.flatDetailPageSize), {
                Type: 0,
                TeacherMasterId: this.flatFilters.teacherMasterId || 0,
                Keyword: this.flatFilters.keyword || ''
            });

            this.flatDetailLoading = true;
            getSpecialAdjustStatisticsDetailList(para).then(res => {
                if (res.success) {
                    this.flatDetailTotal = res.response.dataCount;
                    const rows = res.response.data || [];
                    this.flatDetailList = rows.map(row => ({
                        ...row,
                        AttachmentImageList: this.parseAttachmentImages(row.AttachmentImages)
                    }));
                } else {
                    this.$message.error(res.msg || '获取明细失败');
                }
                this.flatDetailLoading = false;
            }).catch(() => {
                this.flatDetailLoading = false;
                this.$message.error('网络请求异常');
            });
        },
        parseAttachmentImages(raw) {
            if (!raw) return [];
            return String(raw)
                .split(/[,|;]/)
                .map(s => s.trim())
                .filter(Boolean);
        },
        getApplicationRecords(resetPage) {
            if (resetPage) this.appRecordPage = resetPage;
            if (!this.departmentId) return;

            const para = Object.assign(this.buildSharedQueryParams(this.appRecordPage, this.appRecordPageSize), {
                Keyword: this.appFilters.keyword || ''
            });
            if (this.appFilters.status === 0 || this.appFilters.status > 0) {
                para.Status = this.appFilters.status;
            }

            this.appRecordLoading = true;
            getSpecialAdjustApplicationRecords(para).then(res => {
                if (res.success) {
                    this.appRecordTotal = res.response.dataCount;
                    const rows = res.response.data || [];
                    this.appRecordList = rows.map(row => ({
                        ...row,
                        AttachmentImageList: this.parseAttachmentImages(row.AttachmentImages)
                    }));
                } else {
                    this.$message.error(res.msg || '获取申请记录失败');
                }
                this.appRecordLoading = false;
            }).catch(() => {
                this.appRecordLoading = false;
                this.$message.error('网络请求异常');
            });
        },
        handleAppRecordPageChange(val) {
            this.appRecordPage = val;
            this.getApplicationRecords();
        },
        handleAppRecordSizeChange(val) {
            this.appRecordPageSize = val;
            this.getApplicationRecords(1);
        },
        formatAppDateRange(row) {
            if (!row) return '-';
            const start = (row.StartDate || '').toString().substring(0, 10);
            const end = (row.EndDate || '').toString().substring(0, 10);
            if (!start && !end) return '-';
            if (start === end) return start || end;
            return `${start} ~ ${end}`;
        },
        parseLessonList(row) {
            if (!row) return [];
            const rawLessons = row.Lessons || row.lessons;
            if (Array.isArray(rawLessons) && rawLessons.length) {
                return rawLessons.map(item => ({
                    AdjustDate: item.AdjustDate || item.adjustDate,
                    DayOfWeekName: item.DayOfWeekName || item.dayOfWeekName || '',
                    TimeName: item.TimeName || item.timeName || '',
                    ClassName: item.ClassName || item.className || '',
                    CourseName: item.CourseName || item.courseName || '',
                    HandleType: item.HandleType != null ? item.HandleType : item.handleType,
                    HandleTypeName: item.HandleTypeName || item.handleTypeName || '-',
                    NewTeacherName: item.NewTeacherName || item.newTeacherName || '',
                    RelatedAdjustDate: item.RelatedAdjustDate || item.relatedAdjustDate,
                    SummaryText: item.SummaryText || item.summaryText || ''
                }));
            }
            return [];
        },
        getLessonCount(row) {
            if (!row) return 0;
            if (row.DetailCount > 0) return row.DetailCount;
            return this.parseLessonList(row).length;
        },
        getLessonPreview(row) {
            const list = this.parseLessonList(row);
            if (list.length) return list[0].SummaryText || formatFallback(list[0]);
            const summary = (row && (row.LessonSummary || row.lessonSummary)) || '';
            return summary === '-' ? '' : summary;

            function formatFallback(item) {
                const date = (item.AdjustDate || '').toString().substring(0, 10);
                return `${date} ${item.DayOfWeekName || ''} ${item.TimeName || ''}`.trim();
            }
        },
        openApplicationDetail(row) {
            if (!row) return;
            this.applicationDialog.row = row;
            this.applicationDialog.lessonList = this.parseLessonList(row);
            this.applicationDialog.visible = true;
        },
        formatLessonPeriod(row) {
            if (!row) return '-';
            if (row.SummaryText) return row.SummaryText;
            const date = (row.AdjustDate || '').toString().substring(0, 10);
            return `${date} ${row.DayOfWeekName || ''} ${row.TimeName || ''}`.trim() || '-';
        },
        formatDateTime(val) {
            if (!val) return '-';
            return String(val).substring(0, 16).replace('T', ' ');
        },
        appStatusTagType(status) {
            if (status === 1) return 'success';
            if (status === 2) return 'danger';
            if (status === 3) return 'info';
            return 'warning';
        },
        lessonHandleTagType(handleType) {
            if (handleType === 1) return 'warning';
            if (handleType === 3) return 'info';
            return 'success';
        },
        approvalStepTagType(status) {
            const s = (status || '').toLowerCase();
            if (s === 'approved') return 'success';
            if (s === 'rejected') return 'danger';
            return 'warning';
        },
        approvalStepStatusText(status) {
            const s = (status || '').toLowerCase();
            if (s === 'approved') return '已通过';
            if (s === 'rejected') return '已驳回';
            if (s === 'pending') return '待审批';
            return status || '待审批';
        }
    }
};
</script>

<style scoped>
.stat-summary {
    --stat-border: #e5e7eb;
    --stat-bg: #f8fafc;
    --stat-label: #64748b;
    --stat-value: #0f172a;

    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    width: 100%;
    margin: 0 0 12px;
}

.stat-summary-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    min-height: 58px;
    padding: 10px 14px;
    background: var(--stat-bg);
    border: 1px solid var(--stat-border);
    border-radius: 8px;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}

.stat-summary-item.is-clickable {
    cursor: pointer;
}

.stat-summary-item:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
}

.stat-summary-label {
    color: var(--stat-label);
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stat-summary-value {
    color: var(--stat-value);
    font-size: 22px;
    font-weight: 600;
    line-height: 1.15;
    font-variant-numeric: tabular-nums;
}

.cas-tabs {
    margin-top: 4px;
}

.cas-tabs >>> .el-tab-pane > .stat-summary,
.cas-tabs >>> .el-tab-pane > .detail-filter-bar,
.cas-tabs >>> .el-tab-pane > .app-scope-tip {
    flex: 0 0 auto;
}

.cas-tabs >>> .el-tab-pane > .el-col.toolbar {
    flex: 0 0 auto;
    margin-top: 8px;
}

.app-scope-tip {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 8px;
    padding: 6px 10px;
    border: 1px solid #d6e8ff;
    border-radius: 4px;
    background: #f0f7ff;
    color: #475569;
    font-size: 12px;
    line-height: 1.5;
}

.app-scope-tip i {
    margin-top: 2px;
    color: #2563eb;
}

.app-scope-tip strong {
    color: #1e3a5f;
    font-weight: 600;
}

.detail-filter-bar {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    min-height: 32px;
}

.detail-filter-bar .detail-type-select {
    width: 120px !important;
    flex: 0 0 auto;
}

.detail-filter-bar .detail-keyword-input {
    width: 260px !important;
    flex: 0 0 auto;
}

.detail-filter-bar .el-button {
    flex: 0 0 auto;
}

.toolbar-filter-bar .toolbar-field-w-type {
    width: 150px !important;
}

.flat-focus-tag {
    margin-left: 4px;
}

.handle-type-tag {
    white-space: nowrap;
}

.detail-cell-stack {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    line-height: 1.35;
}

.detail-cell-stack.is-left {
    align-items: flex-start;
}

.detail-cell-main {
    color: #303133;
    font-size: 13px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.detail-cell-sub {
    color: #909399;
    font-size: 12px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.app-lesson-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
    cursor: pointer;
    color: #2563eb;
}

.app-lesson-count {
    font-weight: 600;
    font-size: 13px;
}

.app-lesson-preview {
    color: #64748b;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.app-status-cell {
    cursor: pointer;
}

.app-cell-text {
    color: #303133;
    font-size: 13px;
}

.attach-thumbs {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
}

.attach-thumb {
    width: 36px;
    height: 36px;
    border-radius: 4px;
}

.attach-empty {
    color: #94a3b8;
}

.application-detail-dialog {
    color: #606266;
}

/* 申请详情弹窗样式与普通课代调课统计对齐。最后更新：2026-10-22 */
.app-meta-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 14px;
    margin-bottom: 10px;
    padding: 8px 12px;
    border: 1px solid #d6e8ff;
    border-radius: 6px;
    background: #f0f7ff;
}

.app-meta-identity {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    gap: 6px;
}

.app-meta-name {
    color: #334155;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
}

.app-meta-fields {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 16px;
    min-width: 0;
}

.app-meta-field {
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    max-width: 100%;
    color: #475569;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.35;
    white-space: nowrap;
}

.app-meta-field em {
    font-style: normal;
    color: #94a3b8;
    font-weight: 400;
}

.app-meta-field--grow {
    overflow: hidden;
    text-overflow: ellipsis;
}

.flow-panel {
    margin-bottom: 8px;
    padding: 8px 10px;
    border: 1px solid #dbe4f0;
    border-radius: 6px;
    background: #f8fafc;
}

.flow-panel:last-of-type {
    margin-bottom: 0;
}

.flow-panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
}

.flow-panel-title {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    color: #475569;
    font-size: 13px;
    font-weight: 500;
}

.flow-panel-title i {
    color: #2563eb;
    font-size: 14px;
}

.flow-create-time {
    color: #64748b;
    font-size: 12px;
    font-weight: 400;
}

.flow-count {
    flex-shrink: 0;
    padding: 0 6px;
    border-radius: 999px;
    background: #eff6ff;
    color: #2563eb;
    font-size: 11px;
    font-weight: 600;
    line-height: 18px;
}

.app-lesson-table {
    width: 100%;
    color: #606266;
}

.application-detail-dialog ::v-deep .app-lesson-table th,
.application-detail-dialog ::v-deep .app-lesson-table td {
    color: #606266;
    font-weight: 400;
}

.application-detail-dialog ::v-deep .app-lesson-table th {
    color: #909399;
    font-weight: 500;
}

.app-empty-tip {
    padding: 10px 0;
    color: #94a3b8;
    font-size: 12px;
    text-align: center;
}

.approval-steps-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    max-height: 220px;
    overflow-y: auto;
}

.approval-step-card {
    min-width: 0;
    padding: 8px 10px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #fff;
}

.approval-step-card.step-tone-0 {
    border-color: #bfdbfe;
    background: #f8fbff;
}

.approval-step-card.step-tone-0 .step-badge {
    background: #2563eb;
}

.approval-step-card.step-tone-1 {
    border-color: #ddd6fe;
    background: #faf8ff;
}

.approval-step-card.step-tone-1 .step-badge {
    background: #7c3aed;
}

.approval-step-card.step-tone-2 {
    border-color: #99f6e4;
    background: #f0fdfa;
}

.approval-step-card.step-tone-2 .step-badge {
    background: #0d9488;
}

.approval-step-card.step-tone-3 {
    border-color: #fed7aa;
    background: #fff7ed;
}

.approval-step-card.step-tone-3 .step-badge {
    background: #ea580c;
}

.step-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-bottom: 4px;
}

.step-card-main {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
}

.step-badge {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    line-height: 18px;
    text-align: center;
}

.step-name {
    overflow: hidden;
    color: #475569;
    font-size: 13px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.step-card-time {
    color: #94a3b8;
    font-size: 11px;
    line-height: 1.35;
}

.step-card-comment {
    margin-top: 4px;
    padding-left: 6px;
    border-left: 2px solid #bfdbfe;
    color: #64748b;
    font-size: 11px;
    line-height: 1.45;
    word-break: break-word;
    white-space: normal;
}

@media (max-width: 1100px) {
    .stat-summary {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
</style>

<style>
.cas-application-dialog .el-dialog__body {
    padding: 10px 16px 4px;
    color: #606266;
}
</style>
